import Avatar from 'components/Avatar'
import Flex from 'components/Flex'
import LeftArrowIcon from 'components/icons/LeftArrowIcon'
import UserDefaultIcon from 'components/icons/UserDefaultIcon'
import InfoCards from 'components/InfoCards'
import { getDashboardDriveSingleList } from 'modules/Dashboard/actions'
import DriveInfoTable from 'modules/Dashboard/Partials/DashboardDrive/Partials/DriveInfoTable'
import {
  Address,
  CardRow,
  JobDetailsSpan,
  LeftArrowSpan,
  Name,
  NameAdd,
  RoleSpan,
  SectionWrapper,
  TopRoleSection,
} from 'modules/Dashboard/Partials/DashboardRoles/Style/style'
import DriveTabs from 'modules/Dashboard/Partials/DriveTabs'
import { getJobDetails } from 'modules/Roles/actions'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { COLORS } from 'theme'

const DashboardRoles = ({
  rolesList,
  singleRoleDetails,
  getRolesListData,
  updateRoleData,
  setJobId,
  instituteCampusId,
  corporateAboutUs,
  getCities,
  citiesList,
  corporateDetails,
  updatePageNum,
  pageNum,
}) => {
  const params = useParams()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [cardsData, setCardsData] = useState([])
  const [loading, setLoading] = useState(false)
  const [selectionType, setSelectionType] = useState('UPCOMING')
  const [urlQuery, setUrlQuery] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const roleID = params?.roleID
  const [search, setSearch] = useState('')
  const [filterQuery, setFilterQuery] = useState('')
  const [sortQuery, setSortQuery] = useState('')
  const dashboardDriveSingleList = useSelector(
    state => state?.dashboard?.dashboardDriveSingleList
  )
  const singleRoleData = useSelector(state => state?.roles?.singleRoleDetails)
  useEffect(() => {
    dispatch(
      getDashboardDriveSingleList({
        roleID,
        currentPage,
        selectionType,
        search,
        filterQuery,
        sortQuery,
        setLoading,
      })
    )
  }, [
    params.roleID,
    currentPage,
    selectionType,
    search,
    filterQuery,
    sortQuery,
  ])
  useEffect(() => {
    let payLoad = {
      id: params.roleID,
      corporateId: params.corpID,
    }
    dispatch(getJobDetails(payLoad))
  }, [params.corpID])
  useEffect(() => {
    const cardData = [
      {
        key: 1,
        icon: <UserDefaultIcon />,
        text: 'Total Drives',
        value: dashboardDriveSingleList?.count,
        isSelected: false,
      },
      {
        key: 2,
        icon: <UserDefaultIcon />,
        text: 'Drives active',
        value: dashboardDriveSingleList?.activeDriveCount,
        isSelected: false,
      },
      {
        key: 3,
        icon: <UserDefaultIcon />,
        text: 'Students applied / Active',
        value: dashboardDriveSingleList?.totalActiveUniqueCandidatesCount,
        isSelected: false,
      },
      {
        key: 4,
        icon: <UserDefaultIcon />,
        text: 'Corporate actively hiring',
        value: dashboardDriveSingleList?.activelyHriringCorporateCount,
        isSelected: false,
      },
    ]
    setCardsData(cardData)
  }, [dashboardDriveSingleList])

  const changeState = type => {
    setSelectionType(type)
    if (type == 'All') {
      setUrlQuery('')
    } else if (type == 'AcceptedRoles') {
      setUrlQuery('status=1')
    } else {
      setUrlQuery('saved=1')
    }
    setCurrentPage(1)
  }

  const onFilerChange = query => {
    setUrlQuery(query)
  }
  const onSortingChanged = query => {
    setSortQuery(query)
  }
  const onAcceptOrRejectClick = data => {
    setSelecredRole(data)
    setnewAcceptOrRejectDrawer(true)
  }

  const handleArrow = () => {
    navigate(-1)
  }
  return (
    <SectionWrapper column>
      <TopRoleSection>
        <LeftArrowSpan onClick={handleArrow}>
          <LeftArrowIcon />
        </LeftArrowSpan>
        <RoleSpan onClick={handleArrow}>Corporate List</RoleSpan>
        <JobDetailsSpan>/</JobDetailsSpan>
        <RoleSpan onClick={handleArrow}>Roles</RoleSpan>
        <JobDetailsSpan>/</JobDetailsSpan>
        <JobDetailsSpan> View Drive</JobDetailsSpan>
      </TopRoleSection>

      <Flex centerVertically style={{ padding: '20px' }}>
        {singleRoleData?.corporate?.logo ? (
          <Avatar src={singleRoleData?.corporate?.logo} />
        ) : (
          <Avatar
            background
            size={42}
            IconName={singleRoleData?.corporate?.name?.split('')?.[0] || 'H'}
            font={18}
          />
        )}
        <NameAdd column flexStart>
          <Address>{singleRoleData?.corporate?.name}</Address>
          <Flex row>
            {' '}
            <Name>{singleRoleData?.tittle} &nbsp;&nbsp;</Name>{' '}
          </Flex>
        </NameAdd>
      </Flex>

      <CardRow spaceBetween>
        {cardsData?.map(card => (
          <InfoCards
            padding={'20px'}
            width={'25%'}
            icon={card?.icon}
            text={card?.text}
            value={card?.value}
            background={card?.isSelected ? COLORS.BLUE_T_50 : COLORS.BLUE_T_95}
            isSelected={card?.isSelected}
          />
        ))}
      </CardRow>

      <DriveTabs
        selected={selectionType}
        selectedType={type => {
          changeState(type)
        }}
        pastDriveCount={dashboardDriveSingleList?.pastDriveCount}
        upcominngDriveCount={dashboardDriveSingleList?.upcominngDriveCount}
        onGoingDriveCount={dashboardDriveSingleList?.activeDriveCount}
      />
      <br></br>

      <DriveInfoTable
        dashboardDriveSingleList={dashboardDriveSingleList}
        search={search}
        setSearch={setSearch}
        setFilterQuery={setFilterQuery}
        rolesList={rolesList}
        updateRoleData={updateRoleData}
        setJobId={setJobId}
        setUrl={onFilerChange}
        currentUrl={urlQuery}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        getJobDetails={getJobDetails}
        corporateAboutUs={corporateAboutUs}
        corporateDetails={corporateDetails}
        onAcceptOrRejectClick={onAcceptOrRejectClick}
        onSortValueChanged={onSortingChanged}
        loading={loading}
        citiesList={citiesList}
        getCities={getCities}
      />
    </SectionWrapper>
  )
}
export default DashboardRoles
